import { apiPut } from "./http";

export type MemberGroupAssignmentItem = {
  memberGroupKey: string;
  memberGroupName?: string | null;
  memberGroupRoleKey?: string | null;
  memberGroupRoleName?: string | null;
};

export type MemberGroupAssignmentInput = {
  memberGroupKey: string;
  memberGroupRoleKey?: string | null;
};

export type ReplaceMemberGroupsResult = {
  memberGroupKey: string | null;
  memberGroupName: string | null;
  memberGroupRoleKey: string | null;
  memberGroupRoleName: string | null;
  memberGroups: MemberGroupAssignmentItem[];
  changed?: boolean;
};

/** PC 协会后台：替换会员的会员分组（可多选）。 */
export async function putMemberMemberGroups(
  tenantLegacyId: string,
  memberLegacyId: string,
  assignments: MemberGroupAssignmentInput[],
  note?: string | null,
): Promise<ReplaceMemberGroupsResult> {
  const tid = encodeURIComponent(tenantLegacyId.trim());
  const mid = encodeURIComponent(memberLegacyId.trim());
  return apiPut<ReplaceMemberGroupsResult>(`/api/tenants/${tid}/members/${mid}/member-groups`, {
    assignments: assignments.map((a) => ({
      memberGroupKey: a.memberGroupKey.trim(),
      memberGroupRoleKey: a.memberGroupRoleKey?.trim() || "",
    })),
    ...(note?.trim() ? { note: note.trim() } : {}),
  });
}
